/**
 * Branch type.
 **/
export const BranchTypes = {
  BUREAU: "bureau",
  EXPRESS: "express"
};
